export enum ColorTypeEnum {
  Primary = 'primary',
  Warning = 'warning',
  Success = 'success',
  Error = 'error',
}
